import { createSelector } from 'reselect'

const getFull = ({ actions }) => {return actions.list.full}
const getCount = ({ actions }) => actions.list.total
const getCurrent = (state, props) => props.id || null
export const getActions = ({ actions }) => actions.list.items

export const getActionsList = createSelector(
  [ getActions, getCount ],
  (items = [], total = 0) => {
    return ({
    total,
    items,
    length: items.length
  })
}
)

export const getFullActionInfo = () => createSelector(
  [ getFull, getCurrent ],//getfull
  (items, current) => {
	return current ? (items.alias == current || items[current] || null) : null
  }
)



// WEBPACK FOOTER //
// ./src/selectors/actions.js